import styles from "./Divider.module.scss";
import cx from "classnames";

type Props = {
  className?: string;
};

export const Divider = ({ className }: Props) => {
  return <hr className={cx(styles.divider, className)} />;
};

export default Divider;
